import React from 'react'
import { type RPPDomain } from '@retailer-platform/dashboard/core'
import {
  NavItem,
  NavEntryPoint,
  AdminNavEntryPoint,
  AdminNavEntryPointV2,
} from '@retailer-platform/dashboard/routing'
import { NewBadge } from '@retailer-platform/dashboard/gin-and-tonic'
import { v1Router, v3Router, flyerRouter } from './routing/router'
import { retailerCollectionsAdminRouter } from './routing/retailerCollectionsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { retailerCollectionsV3AccessControl } from './access-control/retailerCollectionsV3Access.configuration'
import { retailerCollectionsFlyersAccessControl } from './access-control/retailerCollectionsFlyersAccess.configuration'
import { omeletAccessControl } from './access-control/omeletAccess.configuration'
import { retailerCollectionsV2AdminAccessControl } from './access-control/retailerCollectionsV2AdminAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-collections',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'retailer-collections-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [v1Router],
    partnerScoped: [v3Router, flyerRouter],
    admin: [retailerCollectionsAdminRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Catalog,
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          labelId: 'retailerCollectionsDomain.v3.list.title',
          route: 'retailer-collections-v3',
          accessControl: retailerCollectionsV3AccessControl,
          positionNavV2: 0,
          inToolPermissions: [
            {
              slug: Permission.RetailerCollectionsV2Modify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.RetailerCollectionsV2Modify,
            },
          ],
        },
      ],
    },
    {
      attachTo: NavItem.RetailerFundedMarketing,
      attachToV2: NavEntryPoint.Marketing,
      subNavItems: [
        {
          type: 'item',
          labelId: 'retailerCollectionsDomain.flyers.list.title',
          route: 'retailer-collections-flyers',
          accessControl: retailerCollectionsFlyersAccessControl,
          positionNavV2: 4,
        },
        {
          type: 'item',
          labelId: 'retailerCollectionsDomain.flyers.omelet.title',
          route: 'retailer-collections-flyers-omelet',
          accessControl: omeletAccessControl,
          positionNavV2: 5,
        },
      ],
    },
  ],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.Merchandising,
      attachToV2: AdminNavEntryPointV2.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-retailer-collections-list',
          labelId: 'retailerCollectionsDomain.admin.collections.title',
          accessControl: retailerCollectionsV2AdminAccessControl,
          positionNavV2: 0,
        },
      ],
    },
  ],
}

export default definition
